export default __webpack_public_path__ + "static/media/sticker-wh.3e2b756d.png";